const ESCFooter = () => {
  return (
    <div className="ESCFooter">
      <div className="copyright-footer">
        <p className="footerPStyle">
          <a
            href="http://newbrunswick.rutgers.edu/site-resource/copyright-information"
            target="_blank"
            rel="noreferrer"
          >
            Copyright &#169; 2021
          </a>
          .<br />
          <a href="https://www.rutgers.edu">
            Rutgers, The State University of New Jersey.
          </a>
        </p>
        <p className="footerPStyle">
          Rutgers is an equal access/equal opportunity institution. Individuals
          with disabilities are encouraged to direct suggestions, comments, or
          complaints concerning any accessibility issues with Rutgers websites
          to:{' '}
          <a href="mailto:webmaster@njaes.rutgers.edu">
            accessibility@rutgers.edu
          </a>{' '}
          or complete the{' '}
          <a href="https://it.rutgers.edu/it-accessibility-initiative/barrierform/">
            Report Accessibility Barrier or Provide Feedback Form
          </a>
          .
        </p>
        <p className="footerPStyle">
          Questions or comments about this site? Please contact{' '}
          <a href="mailto:esc@njaes.rutgers.edu">esc@njaes.rutgers.edu</a>
        </p>
      </div>
    </div>
  )
}

export default ESCFooter
